import { useQueryClient } from 'react-query';
import { UserInfoWithLzPzus } from 'api';
import {
  isAppAdmin,
  isAppViewer,
  isCashier,
  isILzAccountant,
  isInspector,
  isLzAdmin,
  isTechSupport,
} from 'common/utils/roles';
import { EQueryConst } from 'features/service/config';

export const useCheckRole = () => {
  const queryClient = useQueryClient();
  const currentUser = queryClient.getQueryData(EQueryConst.CURRENT_USER) as UserInfoWithLzPzus;

  const isAppAdminRole = isAppAdmin(currentUser);
  const isLzAdminRole = isLzAdmin(currentUser);
  const isCashierRole = isCashier(currentUser);
  const isInspectorRole = isInspector(currentUser);
  const isILzAccountantRole = isILzAccountant(currentUser);
  const isAppViewerRole = isAppViewer(currentUser);
  const isTechSupportRole = isTechSupport(currentUser);

  return {
    isAppAdminRole,
    isLzAdminRole,
    isCashierRole,
    isInspectorRole,
    isILzAccountantRole,
    isAppViewerRole,
    isTechSupportRole,
    user: currentUser,
  };
};
